import React, { Component } from "react";
import "./Educations.css";
import DegreeCard from "../../components/degreeCard/DegreeCard.js";
import { degrees } from "../../portfolio.js";
import { Fade } from "react-reveal";
import { withTranslation } from "react-i18next";

class Educations extends Component {
  render() {
    const { t } = this.props;
    const theme = this.props.theme;

    return (
      <div className="m" id="educations">
        <div className="educations-header-div">
          <Fade bottom duration={2000} distance="20px">
            <h1 className="educations-header" style={{ color: theme.text }}>
              {t("educationHeader")}
            </h1>
          </Fade>
        </div>
        <div className="educations-body-div">
          {degrees.degrees.map((degree) => {
            return <DegreeCard degree={degree} theme={theme} />;
          })}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Educations);
